import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
// import ApplicationIndex from "src/applications/shared/features/index";
const ApplicationIndex = lazyWithReload(
  () => import("src/applications/shared/features/index"),
);
import RouteProtector from "./RouteProtector";
// import Acknowledge from "../applications/shared/features/acknowledge/Acknowledge";
const Acknowledge = lazyWithReload(
  () => import("../applications/shared/features/acknowledge/Acknowledge"),
);
// import FormLayout from "../applications/shared/features/form/Form";
const FormLayout = lazyWithReload(
  () => import("../applications/shared/features/form/Form"),
);
// import { SubmitSuccess as ApplicationSubmitSuccess } from "../applications/shared/features/submitSuccess/SubmitSuccess";
const ApplicationSubmitSuccess = lazyWithReload(
  () => import("../applications/shared/features/submitSuccess/SubmitSuccess"),
);
import FormPageRenderer from "../applications/shared/lib/FormRenderByPath/FormPageRenderer";

const SuccessfullSubmit = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/applicationSucess/SuccessfullSubmit"
    ),
);

const Appl120Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-120-correction/features/create/appl120Form"
    ),
);

export const applicationPaths: RouteObject = {
  path: "/application",
  // element: <RedirectQueryParamPath />, // by using this element we redirect old URLs to new Ones
  children: [
    // Old Paths
    {
      path: "submissionSuccess",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isChamber"]}>
          <ApplicationSubmitSuccess />
        </RouteProtector>
      ),
    },
    {
      path: "index",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ApplicationIndex />
        </RouteProtector>
      ),
    },
    {
      path: "form",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <FormLayout />
        </RouteProtector>
      ),
    },
    {
      path: "acknowledge",
      element: (
        <RouteProtector
          allowedUsers={["isBusiness", "isChamber", "isSystemAdmin"]}
        >
          <Acknowledge />
        </RouteProtector>
      ),
    },

    // New Paths
    {
      path: ":id/index",
      element: (
        <RouteProtector allowedUsers={["isChamber", "isBusiness"]}>
          <ApplicationIndex />
        </RouteProtector>
      ),
    },
    {
      path: ":id/form",
      element: (
        <RouteProtector
          allowedUsers={["isChamber", "isBusiness", "isSystemAdmin"]}
        >
          <FormLayout />
        </RouteProtector>
      ),
    },
    {
      path: ":id/correctionForm",
      element: (
        <RouteProtector
          allowedUsers={["isChamber", "isBusiness", "isSystemAdmin"]}
        >
          <Appl120Form />
        </RouteProtector>
      ),
    },
    {
      path: ":id/acknowledge",

      element: (
        <RouteProtector
          allowedUsers={["isChamber", "isBusiness", "isSystemAdmin"]}
        >
          <FormPageRenderer path="acknowledge" />
        </RouteProtector>
      ),
    },
    {
      path: "publicCompSubmissionSuccess",
      element: (
        <RouteProtector allowedUsers={["isChamber", "isBusiness"]}>
          <SuccessfullSubmit publicComp={true} />
        </RouteProtector>
      ),
    },
    {
      path: "success",
      element: (
        <RouteProtector allowedUsers={["isChamber", "isBusiness"]}>
          <SuccessfullSubmit publicComp={false} />
        </RouteProtector>
      ),
    },
  ],
};
